import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
  OnDestroy,
  OnChanges
} from '@angular/core';
import { Answer } from '../../../../../../models/suitability/answer';
import { ReactiveControlValidator } from '../../../../../../abstration/control-validator';
import { FormControl, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-text-answer',
  templateUrl: './text-answer.component.html',
  styleUrls: ['./text-answer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TextAnswerComponent extends ReactiveControlValidator implements OnInit, OnChanges {

  @Input() answer = new Answer();
  @Output() onAnswerValueChange = new EventEmitter<Answer>();
  @Input() value = new Answer();
  @Input() disabled = false;

  formControl: FormControl;

  constructor(protected formBuilder: FormBuilder) {
    super(formBuilder);
  }

  ngOnInit() {
    if (this.value) {
      this.formControl.setValue(this.value.value);
    }
  }

  ngOnChanges() {
    if (this.value) {
      this.formControl.setValue(this.value.value);
    }
  }

  initReactiveForms(): void {
    this.formControl = this.formBuilder.control(0, Validators.required);

    this.formControl
      .valueChanges
      .pipe(
        map((value) => this.onAnswerValueChange.emit({ ...this.answer, value: value }))
      )
      .subscribe();
  }

  getAnswerID(): string {
    return this.answer.id;
  }
}
